import React, { useEffect } from "react";
import "./OurFleets.css";
import { MdFamilyRestroom } from "react-icons/md";
import { RxCrossCircled } from "react-icons/rx";
import { TbBottle } from "react-icons/tb";
import car from "./../../assets/images/car2.png";
import { FaUserFriends } from "react-icons/fa";
import { BsBagFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { getAllVehicles } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";

import { MdAccessTimeFilled } from "react-icons/md";
import Loader from "../Loader/Loader";
const OurFleets = () => {
  const dispatch = useDispatch();
  const vehiclesData = useSelector(
    (state) => state?.AdminReducer?.allVehiclesData
  );

  useEffect(() => {
    dispatch(getAllVehicles());
  }, []);

  return (
    <>
    <Loader/>
      <div className="mainOurServices">
        <div className="ourServiceTxt">Our Fleets</div>

        <div className="middleLine"></div>
        <div className="ourServTxtPara">
          Explore The UK With Experienced Drivers.
        </div>
      </div>

      <div className="mainContainerVehiclFleets">
        <div className="mainContainerVehiclFleetsInner">
          {vehiclesData?.map((item) => (
            <div className="cardFleetVehicle">
              <div className="fleetCardLeft">
                <img src={item.image} className="imgFleetVehicle" />
                <div className="topMiddleStprBooking">
                  <MdAccessTimeFilled />
                  <div className="txtMiddleStpBok">
                    Free 60 minutes wait time for airport pickups, 15 mins for
                    all others
                  </div>
                </div>
                <div className="topMiddleStprBooking">
                  <RxCrossCircled />
                  <div className="txtMiddleStpBok">
                    Free cancellation up until 1 hour before pickup
                  </div>
                </div>
                <div className="topMiddleStprBooking">
                  <MdFamilyRestroom />
                  <div className="txtMiddleStpBok">Includes Meet & Greet</div>
                </div>
                <div className="topMiddleStprBooking">
                  <TbBottle />
                  <div className="txtMiddleStpBok">
                    Complimentary bottled water
                  </div>
                </div>
              </div>

              <div className="fleetCardRight">
                <div className="rightHeadingFleet">{item.catagory}</div>

                <div className="lineFleetCard"></div>

                <div className="fleetVehicleType">
                  ({item.company})
                </div>

                <div className="topVehicleDetFleet">
                  <div className="topPassCapFleet">
                    {item.passenger} x <FaUserFriends />
                  </div>
                  <div className="topPassCapFleet">
                  {item.luggage} x <BsBagFill />
                  </div>
                  <div className="topPassCapFleet1">
                  {item.luggage} x <BsBagFill />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default OurFleets;
